var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row mb-3" }, [
    _c("div", { staticClass: "col" }, [
      _vm.uploadstatus
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm._f("translate")("Uploading")) + "..."),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "progress mb-4",
                  attrs: {
                    role: "progressbar",
                    "aria-label": "Upload progress",
                    "aria-valuenow": _vm.uploadstatus,
                    "aria-valuemin": "0",
                    "aria-valuemax": "100",
                  },
                },
                [
                  _c("div", {
                    staticClass:
                      "progress-bar progress-bar-striped progress-bar-animated",
                    style: `width: ${_vm.uploadstatus}%`,
                  }),
                ]
              ),
            ]),
          ])
        : _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body px-4 px-lg-5" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-light text-start",
                  on: { click: _vm.showModal },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("translate")("Add")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "postCreateModal",
          staticClass: "modal fade",
          attrs: {
            tabindex: "-1",
            "aria-labelledby": "postCreate",
            "aria-hidden": "true",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "exampleModalLabel" },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm._f("translate")("Add")) +
                        " " +
                        _vm._s(_vm._f("translate")("post"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("button", {
                  staticClass: "btn-close",
                  attrs: {
                    type: "button",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "mb-3" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.title,
                        expression: "title",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      max: "160",
                      placeholder: _vm.$t("Title"),
                    },
                    domProps: { value: _vm.title },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.title = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.body,
                        expression: "body",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      cols: "30",
                      rows: "10",
                      placeholder: _vm.$t("Content"),
                    },
                    domProps: { value: _vm.body },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.body = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.imagePreview
                  ? _c("div", { staticClass: "mb-3" }, [
                      _c("img", {
                        staticClass: "img-fluid",
                        attrs: { src: _vm.imagePreview, alt: "" },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showImageUpload
                  ? _c("div", { staticClass: "mb-3" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: {
                          type: "file",
                          id: "formFile",
                          accept: "image/png, image/gif, image/jpeg",
                        },
                        on: { change: _vm.fileUpload },
                      }),
                      _vm._v(" "),
                      _vm.uploadError
                        ? _c("small", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(_vm.uploadError)),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showVideoUpload
                  ? _c("div", { staticClass: "mb-3" }, [
                      _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.video,
                              expression: "video",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "video-url",
                            name: "",
                            type: "text",
                            placeholder: "Embed url (Vimeo, YouTube)",
                          },
                          domProps: { value: _vm.video },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.video = $event.target.value
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-3" }, [
                        !_vm.video_file_upload && !_vm.video_file
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  on: { click: _vm.addVideo },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm._f("translate")("Choose file")
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.video_file
                          ? _c("div", [
                              _c("div", { staticClass: "ratio ratio-16x9" }, [
                                _c("video", { attrs: { src: _vm.fileUrl } }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-link text-secondary btn-sm",
                                  on: { click: _vm.removeVideo },
                                },
                                [_c("i", { staticClass: "fas fa-trash" })]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c("div", [
                    !_vm.showVideoUpload
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sm me-1",
                            on: { click: _vm.toggleImageUpload },
                          },
                          [
                            _vm.showImageUpload
                              ? _c("i", { staticClass: "fas fa-times" })
                              : _c("i", { staticClass: "far fa-image" }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.showImageUpload
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-link btn-sm",
                            on: { click: _vm.toggleVideoUpload },
                          },
                          [
                            _vm.showVideoUpload
                              ? _c("i", { staticClass: "fas fa-times" })
                              : _c("i", { staticClass: "far fa-play-circle" }),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-bs-dismiss": "modal" },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm._f("translate")("Cancel")) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: [
                      "btn",
                      "btn-primary",
                      _vm.isValid ? "" : "disabled",
                    ],
                    attrs: { type: "button" },
                    on: { click: _vm.createPost },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm._f("translate")("Create")) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }